import { addSeconds } from 'date-fns';

export function getCacheHeaders(time = 0) {
    let expiresAt = time === 0 ? 0 : addSeconds(new Date(), time).toUTCString();
    let mustRevalidate = time === 0 ? ',must-revalidate' : '';
    return { 'cache-control': 'private,max-age=' + time + mustRevalidate, expires: expiresAt };
}
